export const BLOGS_DATA = [
  {
    id: "1",
    blogId: "check-the-safest-and-surest-way-to-check-loose-dropping-in-poultry",
    img: "/img/blogs/blog_1.jpg",
    title: "CHECK® - THE SAFEST AND SUREST WAY TO CHECK LOOSE DROPPING IN POULTRY",
    intro: `Loose droppings, or diarrhoea, are among the most common and concerning issues in poultry farming.
    They not only affect bird comfort but also reduce productivity, increase mortality risk, and raise treatment costs.
    Diarrhea is not a disease itself; it is a symptom that can arise due to several reasons:`,

    reasons: [
      {
        label: "Nutritional factors",
        text: "sudden changes in diet, poor-quality feed, or an imbalance in nutrients.",
      },
      {
        label: "Infectious causes",
        text: "bacterial, viral, or parasitic infections such as E. coli, Salmonella, or coccidiosis.",
      },
      {
        label: "Antibiotic-induced imbalance",
        text: "prolonged or excessive use of antibiotics disturbs the natural gut flora.",
      },
      {
        label: "Environmental stress",
        text: "poor hygiene, contaminated water, and over-specialized extreme temperatures.",
      },
      {
        label: "Hormonal or metabolic issues",
        text: "relatively rare but require specialized veterinary care.",
      },
    ],

    subHeading: "Why Antibiotics Are Not the Best Solution",

    antibioticsIntro: `For decades, antibiotics have been the go-to treatment for controlling diarrhea. While they may
    suppress harmful bacteria temporarily, their disadvantages outweigh the benefits:`,

    antibioticPoints: [
      "Kill both harmful and beneficial bacteria, thereby disrupting the natural balance of the gut.",
      "Reduce feed intake and growth due to stress on the digestive system.",
      "Weaken long-term resistance, leaving birds prone to repeat infections.",
      "Raise concerns about residues in meat and eggs, which impact food safety and consumer trust.",
    ],

    conclusion: `Given the drawbacks of antibiotics, there is a pressing need for safe, fast-acting, and antibiotic-free alternatives.
    This is not just a preference, but a necessity for the health and productivity of your flock.`,
    
    highlightone: `CHECK® is a specially formulated probiotics-based, natural, safe product that provides
        rapid and reliable control of diarrhoea in poultry without side effects in less than 6 hours.
        It helps restore gut health and flock productivity, regardless of the cause, whether infectious, nutritional,
        or antibiotic induced (except in cases involving hormonal imbalance, which is necessary for growth).`,
    

    highlighttwo: {
      intro: `CHECK® is a specially formulated probiotics-based, natural, safe product that provides rapid and reliable control of diarrhoea in poultry without side effects in less than 6 hours. It helps restore gut health and flock productivity, regardless of the cause, whether infectious, nutritional, or antibiotic induced (except in cases involving hormonal imbalance, which is necessary for growth).`,
      multiTargetApproach: [
        "Restoring gut microbial balance with beneficial probiotics.",
        "Neutralising bacterial toxins and preventing further intestinal damage.",
        "Flushing out harmful pathogens through binding action.",
        "Activating the immune system to resist infections and improve resilience.",
        "Providing quick energy to support faster recovery.",
      ],
      combinedAction: `This combined action ensures that diarrhoea - whether due to infection, feed imbalance, or antibiotic side effects - is controlled safely, rapidly, and without the drawbacks of antibiotics.`,
      benefits: [
        "Fast action without negative side effects.",
        "Improves digestion and feed conversion ratio (FCR).",
        "Reduces inflammation and pathogen load.",
        "Protects the gastrointestinal and respiratory tracts.",
        "Boosts non-specific immunity for long-term resistance.",
        "Safe for preventive use at regular intervals.",
        "100% free from antibiotics and chemical residues.",
      ],
      dosage: [
        "Dosage: 200g of CHECK® for 5000 chicks/broilers/layers/breeders.",
        "Administer in the first water or feed of the day at the first sign of loose droppings.",
        "Preferably given through water; if water sanitisers are used, mix them in with the feed instead. Ensure uniform and thorough mixing.",
        "Dosage may be adjusted depending on flock conditions and veterinary advice.",
      ],
      presentation: [
        "200g multilayer food-grade aluminum packs with a duplex carton box and bulk pails available for larger farm use.",
      ],
      conclusion: [
        "Antibiotics can be effective in managing loose droppings; however, they may also harm gut health and decrease productivity. Fortunately, CHECK® offers a natural, safe probiotics formulation, an antibiotic-free solution that is scientifically proven to work quickly. It boosts immunity, reduces mortality, improves dry matter retention, and enhances the overall wellness of your flock. Embrace a healthier approach today."
      ],
    },
  },
  {
    id: "2",
    blogId: "biofence-stage-I-day-old-chick-spray",
    img: "/img/blogs/blog_2.png",
    title: "BIOFENCE® STAGE-I",
    subTitle: "Day old chick spray for Maximum Liveability, Immunity and Growth",
    content: [
      {
        type: "paragraph",
        text: "Hatcheries for chicks provide controlled conditions, including optimal temperature, humidity, and biosecurity. Chicks leaving the hatchery face a sudden and profound challenge. The move out exposes them to multiple stressors, including drastic changes in environmental parameters (temperature, humidity, and lighting), stacking, and a critical period of no external feed and water during transportation.",
      },
      {
        type: "paragraph",
        text: "Chicks after hatching have a sterile gut, with remnants of yolk found on their body, which serve as a good nutritional source. Moving out of the hatchery, chicks are susceptible to pathogen contamination, which affects their gut habitat and can potentially lead to serious infections and high mortality rates. These opportunistic pathogens quickly colonise the gut, impacting health and severely compromising long-term performance, leading to mortality.",
      },
      {
        type: "paragraph",
        text: "Recognising this critical window for initial gut stabilisation, INTRON's R&D division has developed BIOFENCE® STAGE-I. This is the world's first TRIBIOTIC® - a groundbreaking, scientifically formulated solution that combines prebiotics, probiotics, and postbiotics to deliver comprehensive and early-life protection.",
      
      },
      {
        type: "image",
        src: "/img/blogs/blog_2_img.png",
        alt: "BIOFENCE® STAGE-I",
        width: "60%",
        height: "300px",
      },
      {
        type: "paragraph",
        text: "The unique TRIBIOTC® works individually and in synergy, promoting better gut health, supporting nutrient absorption, and improving growth and disease resistance immediately after hatching. This helps chicks start strong with improved overall health and performance.",
      },
      {
        type: "paragraph",
        text: "The application of BIOFENCE® STAGE-I has demonstrated significant improvements in poultry growth, health and performance, notably reducing chick mortality and promoting improved chick movement and uniformity across the flock.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_2.png",
        alt: "BIOFENCE® STAGE-I",
      },
      {
        type: "heading",
        text: "The Smart Spray: Leveraging the Natural Preening Reflex",
      },
      {
        type: "paragraph",
        text: "The delivery method of BIOFENCE® STAGE-I is simple. Mix 100 grams of the product in 3-4 L of plain, additive-free water (excluding antibiotics, feed supplements, or sanitisers) to make an orange-coloured viscous liquid. This solution is then sprayed on the chicks in the hatchery or on the farm immediately upon arrival. BIOFENCE® STAGE-I, upon mixing water, forms a thick solution, and this can be used as supplemental feed during the transportation of chicks. Crucially, the proprietary orange colour naturally attracts the chicks and stimulates the preening reflex.",
      },
      {
        type: "paragraph",
        text: "As they preen, the formulation is seamlessly transferred from feather to beak, ensuring the probiotics are ingested for effective gut colonisation and also takes advantage of the yolk residues on the chick's body to outcompete the pathogens.",
      },
      {
        type: "list",
        title: "Key Benefits of BIOFENCE® STAGE-I",
        items: [
          "Helps the birds establish initial gut microbiota",
          "Protects against colonisation of harmful and pathogenic microorganisms on the bird's body, utilizing residues from hatching eggs instead utilizes the residues to establish a friendly, useful probiotic microbiota",
          "Helps the chicks attain better and faster gut integrity",
          "Improves the overall immunity status of the chicks for a great start",
          "Acts as a supplemental feed and enhances digestion and FCR",
          "Improves flock liveability",
          "Reduces the risk of disease",
          "infections and the need for frequent medication",
        ],
      },
      {
        type: "heading",
        text: "Practical, Safe, and Cost-Effective Integration",
      },
      {
        type: "paragraph",
        text: "BIOFENCE® STAGE-I is available in practical 10g sachets for 1000 chicks, 100g tins with TOSSPACK for 10,000 chicks, and bulk pails. Its simple preparation and natural, stress-free delivery method (basic sprayers instead of costly & complicated applicators) ensure uniform microbial exposure across the largest batches of chicks.",
      },
      {
        type: "video",
        src: "/img/video/video_1.mp4",
        height: "400px",
      },
      {
        type: "heading",
        text: "Conclusion",
      },
      {
        type: "conclusion-paragraph",
        text: "BIOFENCE® STAGE-I represents a fundamental shift in early life poultry care - a remarkable fusion of advanced scientific TRIBIOTIC™ technology and an understanding of innate chick instincts. By guaranteeing stronger immunity and enhancing performance from the first hour, INTRON sets a new industry benchmark for healthier, more sustainable poultry production.",
      },
    ],
  },
  {
    id: "3",
    blogId: "redefining-feed-additives-intron-global-benchmark",
    img: "/img/blogs/blog_3.jpg",
    title: "Redefining Feed Additives: How INTRON's Concepts Set a New Global Benchmark in the Animal Health Industry",
    content: [
      {
        type: "paragraph",
        text: "The global animal health industry is at a turning point - where performance must align with sustainability, safety, and antibiotic-free production. Over 27 years of industrial experience, Intron Life Sciences has a strong Research & Development team, and our focus has always been clear: develop technologies rooted in strong science, practical applicability, and uncompromising quality. Over the years, this commitment has led us to create innovations that stand apart across poultry, aquaculture, livestock, and companion animal health.",
      },
      {
        type: "paragraph",
        text: "INTRON’s approach is built on a series of breakthrough concepts that redefine feed additive performance:",
      },
      {
        type: "heading",
        text: "1. Proprietary Microbial Strains: The Core of Our Innovation",
      },
      {
        type: "paragraph",
        text: "Probiotics play a crucial role in overall animal health, pond environment, growth, immunity, and overall performance. Not all microbial strains function equally - performance varies across species. INTRON addresses this through species-specific, proprietary strains rigorously validated for consistency and efficacy. Each strain undergoes metabolite screening, stability, performance and safety studies under laboratory and field conditions. All these proprietary strains are available in our probiotic-based formulations, and the INTRON’s quality standards ensure consistent results",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.1.png",
        alt: "Probiotic Strains",
      },
      {
        type: "heading",
        text: "2. TRIBIOTIC®",
      },
      {
        type: "paragraph",
        text: "INTRON is proud to introduce the world's first TRIBIOTIC®, combining Probiotics, Prebiotics and Postbiotics. This three-in-one approach supports animals through gut development and immunomodulation. With TRIBIOTIC®, producers achieve faster gut flora stabilisation, improved resilience to stress, and better growth performance. The TRIBIOTIC® concept is applied in our products BIOFENCE® STAGE I, BIOFENCE® STAGE II and BIOFENCE® STAGE III in Poultry and BIOFENCE® AQUA in Aquaculture.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.2.png",
        alt: "TRIBIOTIC®",
      },
      {
        type: "heading",
        text: "3. QUADRAMAX® technology",
      },
      {
        type: "paragraph",
        text: "INTRON developed QUADRAMAX®, a comprehensive blend of Probiotics, Prebiotics, Postbiotics and Phytobiotics. Each component works independently and together, the four-way synergy creates a stronger and more resilient gut environment than any single-category solution, and this has been used in our product DYNAGRO®.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.3.png",
        alt: "QUADRAMAX® technology",
      },
      {
        type: "heading",
        text: "4. Lyophilised Technology for Maximum Stability",
      },
      {
        type: "paragraph",
        text: "Probiotic viability determines product efficacy, but many products degrade before they even reach the farm. INTRON uses advanced lyophilisation technology, helping probiotic cells with longer shelf life, better quality and improved activity.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.4.png",
        alt: "Lyophilised Technology for Maximum Stability",
      },
      {
        type: "heading",
        text: "5. Naturelle™ – Harnessing Phytobiotics for Natural Health Defense",
      },
      {
        type: "paragraph",
        text: "Nature has its own pharmacy, and INTRON's Naturelle division is built to capture it. Products from Naturelle are formulated mainly with phytobiotics like Phytoalkaloids, Phytopeptides etc., Naturelle products support digestion, immunity, stress resilience, and natural pathogen control without contributing to resistance or residue issues. BANVIRTM, SNIFFLEX®, XKLUDE®, INTRAGUARDTM, OVOPT®, VIRILOPT®, and ACIVITY® in Poultry, and ALBATREAT®, REBOOT®, and INSTRASHIELD® in Aquaculture are Naturelle-based products.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.5.png",
        alt: "Naturelle™ – Harnessing Phytobiotics for Natural Health Defense",
      },
      {
        type: "heading",
        text: "6. TOSSPACK® – Pouches for Safe and Clean Handling",
      },
      {
        type: "paragraph",
        text: "Biosecurity begins at the farm gate, and contamination often occurs at the point of handling. INTRON's TOSSPACK® concept with premeasured, water-soluble packs in prime products (TOTAL®, TOXOFF® and BIOFENCE® products) eliminates this risk, helping farmers avoid direct contact with the product; makes it easy to use by tossing into the required area in case of Aquaculture; prevents cross-contamination; and enables accurate dosing with a faster, cleaner, and safer application.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.6.png",
        alt: "TOSSPACK® – Pouches for Safe and Clean Handling",
      },
      {
        type: "heading",
        text: "7. Fully Compliant With NAE/ABF Programs",
      },
      {
        type: "paragraph",
        text: "Antimicrobial resistance is a major threat; producers worldwide are slowly shifting to No Antibiotics Ever (NAE) and Antibiotic-Free (ABF) programmes. The INTRON products are compatible with the NAE/ABF programs. This helps INTRON to be a reliable partner for farms transitioning to sustainable, residue-free production.",
      },
      {
        type: "image",
        src: "/img/blogs/blog_3.7.png",
        alt: "Fully Compliant With NAE/ABF Programs",
      },
      {
        type: "heading",
        text: "The INTRON Promise: Where Science Meets Sustainable Performance",
      },
      {
        type: "paragraph",
        text: "At INTRON, innovation goes beyond products, it is about shaping the future of animal health. Backed by deep research and strong scientific principles, our technologies enable farmers to achieve consistent performance while transitioning toward antibiotic-free, sustainable production systems.",
      },
      {
        type: "paragraph",
        text: "From proprietary microbial strains to advanced probiotic technologies and Naturelle formulations, INTRON delivers solutions that build confidence, protect animal health, and set new global benchmarks.",
      },
      {
        type: "conclusion-paragraph",
        text: "From proprietary strains to lyophilised probiotics, from TRIBIOTIC® and QUADRAMAX® innovations to plant-powered Naturelle formulations, our solutions are designed to give farmers confidence, protect animal health, and enable antibiotic-free performance.",
      },
    ],
  },
];